@if(state){<p class="text-center text-secondary fs-5">{{'poll_creation.preview' | translate}}</p>
    <div class="preview-item">
        <div class="border rounded bg-white card kudos-card position-relative">
                <!-- Topic card ligth version -->
                <div class="">
                    <div class="card-top">
                            <div class="pe-2">
                                @switch (topic.type){
                                    <!-- @case ('topic'){
                                        <div class="pt-2 pe-2">
                                            <i class="fa-light fa-messages-question fa-2x ms-2 pt-1 position-relative" [ngClass]="{'text-secondary': timelineItemEditMode}"></i>
                                        </div>
                                    } -->
                                    @case ('question'){
                                        <div class="pt-2 pe-2">
                                            <i class="fa-light fa-messages-question  fa-2x ms-2 pt-1 position-relative text-secondary"></i>
                                        </div>
                                    }
                                    @case ('issue'){
                                        <div class="pt-2 pe-2">
                                            <i class="fa-light fa-message-exclamation fa-2x ms-2 pt-1 position-relative text-secondary"></i>
                                        </div>
                                    }
                                }
                            </div>
                        <div class="w-100">
                            <div class="card-comment p-3">
                                <span class="card-comment-body fst-italic" [innerHtml]="$safeNavigationMigration(topic.title.body) | removeGifUrls: $safeNavigationMigration(gifPreviews) | linky"></span>
                                @if(gifPreviews?.length > 0){
                                    @for (gifPreview of gifPreviews; track gifPreview.url){
                                        <tm-gif-preview [gifPreview]="gifPreview"></tm-gif-preview>
                                    }
                                }
                            </div>

                        </div>
                    </div>  
                </div>
                 <!--  -->                
        </div>
        <div class="pb-4">
            @if(state === 'create' || state === 'notify' || state === 'publish'){
                <div class="preview-item">
                    <anonymity-preview [userInfos]="userInfos"
                                       [itemType]="topic.type"
                                       [isAnonymous]="true"></anonymity-preview>
                </div>
            }
            @if(state === 'notify' || state === 'publish'){
                <div class="preview-item">
                    <notification-preview [itemType]="topic.type"
                                          [notify]="notify"></notification-preview>
                </div>
            }
            @if(state === 'publish'){
                <div class="preview-item">
                    <publication-preview [itemType]="topic.type"
                                         [publishNow]="true"></publication-preview>
                </div>
            }
        </div>
    </div>
}